const moduleRoutes = [
    {
        path: '/referral-setup',
        name: 'referralSetups',
        children: [
            {
                path: '',
                name: 'referralSetupList',
                component: () => import('@/modules/referral_setup/list/list.vue'),
                meta: {
                    resource: 'referral-setups',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Referral Setup',
                    breadcrumbs: [{ title: 'Referral Setup', routeName: 'referralSetupList' }]
                }
            },
            {
                path: 'new',
                name: 'referralSetupNew',
                component: () => import('@/modules/referral_setup/entry/New.vue'),
                meta: {
                    resource: 'referral-setups',
                    action: 'action',
                    layout: 'default',
                    auth: true,
                    title: 'New Referral Setup',
                    breadcrumbs: [
                        { title: 'Referral Setup', routeName: 'referralSetupList' },
                        { title: 'New', routeName: 'referralSetupNew' }
                    ]
                }
            },
            {
                path: ':id/edit',
                name: 'referralSetupEdit',
                component: () => import('@/modules/referral_setup/entry/Edit.vue'),
                meta: {
                    resource: 'referral-setups',
                    action: 'action',
                    layout: 'default',
                    auth: true,
                    title: 'Edit Referral Setup',
                    breadcrumbs: [
                        { title: 'Referral Setup', routeName: 'referralSetupList' },
                        { title: 'Edit', routeName: 'referralSetupEdit' }
                    ]
                }
            }
        ]
    }
]

export default moduleRoutes
